import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { IconButton } from '@picsio/ui';
import { Close } from '@picsio/icons';
import localization from '../shared/strings';
import Tooltip from '../components/Tooltip';

import { COLOR_LABELS } from '../helpers/colorsHelper';
import { selectColorOptions } from '../store/selectors/colorLabels';

const Colors = ({
  value = [],
  onChange = () => null,
  className = '',
  highlight = false,
  error = false,
  disabled = false,
  deselectColors = null,
  highlightAnimationReset = () => null,
}) => {
  const colors = useSelector(selectColorOptions);

  const handleAnimationEnd = useCallback(
    () => highlightAnimationReset('color'),
    [highlightAnimationReset],
  );

  const handleChange = useCallback(
    (event) => {
      const colorValue = event.currentTarget.dataset.color || COLOR_LABELS.noColor;
      if (!disabled) onChange(colorValue);
    },
    [disabled, onChange],
  );

  return (
    <div
      className={cn('defaultColorList', className, { isError: error, disabled })}
      onAnimationEnd={handleAnimationEnd}
    >
      <ul
        className={cn({
          highlightBlink: highlight,
        })}
      >
        {colors.map((color) => (
          <Tooltip key={color.value} content={color.title} placement="top">
            <li
              onClick={handleChange}
              data-color={color.value}
              className={value.includes(color.value) ? 'act' : ''}
            >
              <span
                className={`filterLabelColor ${!color.background ? 'filterUnlabeledColor' : ''}`}
                style={{ background: color.background || '' }}
              />
            </li>
          </Tooltip>
        ))}
        <If condition={deselectColors}>
          <Tooltip content={localization.DETAILS.textDeselectColors} placement="top">
            <li
              className="deselectColors"
            >
              <IconButton size="lg" onClick={deselectColors}>
                <Close />
              </IconButton>
            </li>
          </Tooltip>
        </If>
      </ul>
    </div>
  );
};

Colors.propTypes = {
  className: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  onChange: PropTypes.func,
  highlight: PropTypes.bool,
  error: PropTypes.bool,
  disabled: PropTypes.bool,
  highlightAnimationReset: PropTypes.func,
  deselectColors: PropTypes.func,
};

export default Colors;
